import Select from './util/multiSelect';

$(document).ready(()=>{
    init();
});


function init(){
    let tab = new Tab('.tab--blood');
    let select_server = new Select('.select--server');
    let select_name = new Select('.select--name');
    let select_1st = new Select('.select--1st');
    let select_2st = new Select('.select--2st');
    let select_3st = new Select('.select--3st');
    let select_4st = new Select('.select--4st');
    let select_5st = new Select('.select--5st');

    window.pageMainLayer = promokit.layer({
        contents: '#p-layer__choice',
        render: true
    });
}


class Tab{
    constructor(box) {
        this.$box = $(box);
        this.$btn = this.$box.find('.tab__btn');
        this.$con = this.$box.find('.tab__con');

        this.init();
    }

    init() {
        this.bindEvent();
    }

    action(t) {
        let tabID = $(t).data().tab;
        this.$btn.removeClass('active');
        $(t).addClass('active');
        this.$con.hide();
        this.$con.each( (idx,elem) => $(elem).data().tabCon == tabID ? $(elem).show() : '' );
    }

    bindEvent() {
        this.$btn.on('click', (e)=>{ this.action(e.target) } );
    }
}


// WEBPACK FOOTER //
// ./src/js/blood.js